module.exports = "<span *ngIf='showing && total' class='showing'>\n  Showing {{ showing }} of {{ total }}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search-count/search-count.component.html
// module id = ./src/app/shared/search-count/search-count.component.html
// module chunks = main